import { Actions } from "vuex-smart-module";
import axios from "@/web_client/axios_config";
import router from "@/router";

import UserState from "./state";
import UserMutations from "./mutations";
import UserGetters from "./getters";
import Urls from "@/web_client/urls";
import { MutationTypes } from "../mutations-types";
import { auth } from "@/store";

const userUrl = Urls.userUrls;

export default class UserActions extends Actions<
  UserState,
  UserGetters,
  UserMutations,
  UserActions
> {
  userRequest() {
    axios
      .get(userUrl.me)
      .then((resp) => {
        this.commit(MutationTypes.USER_SUCCESS, resp.data);
        //Redirección a página principal
        router.push("/");
      })
      .catch(() => {
        this.commit(MutationTypes.USER_ERROR);
        auth.dispatch("authLogout");
      });
  }
}
